import { TaskStatusEnum } from "@shared/enums";
import { ActionTask } from "@shared/classes/general";

export class TaskManagerHelper {
  /**
  * Check if a task in Task Manager is executing.
  * Executing - EXECUTING/TIMEOUT/RESUMING
  *
  * @param taskManager Task Manager
  * @param taskName Target Task Name
  * @param taskId Target Task Id
  */
  static IsTaskExecuting = (taskManager: ActionTask[], taskName: string, taskId?: string) => {
    const task = taskManager.find(t => t.taskName == taskName && (!taskId || t.taskId === taskId));
    if (!task) return false;
    return task.status != TaskStatusEnum.COMPLETED && task.status != TaskStatusEnum.FAILED;
  }

  /**
  * Check if a task in Task Manager is completed.
  * Completed - COMPLETED/FAILED
  *
  * @param taskManager Task Manager
  * @param taskName Target Task Name
  * @param taskId Target Task Id
  */
  static IsTaskCompleted = (taskManager: ActionTask[], taskName: string, taskId?: string) => !TaskManagerHelper.IsTaskExecuting(taskManager, taskName, taskId);

  /**
* Check if a task in Task Manager is completed.
* Completed - COMPLETED/FAILED
*
* @param taskManager Task Manager
* @param taskName Target Task Name
* @param taskId Target Task Id
*/
  static IsTaskSuccessed = (taskManager: ActionTask[], taskName: string, taskId?: string) => {
    const task = taskManager.find(t => t.taskName == taskName && (!taskId || t.taskId === taskId));
    if (!task) return false;
    return task.status === TaskStatusEnum.COMPLETED;
  };

  static GetTaskError = (taskManager: ActionTask[], taskName: string, taskId?: string) => {
    const task = taskManager.find(t => t.taskName == taskName && (!taskId || t.taskId === taskId));
    if (!task) return undefined;
    return task.status === TaskStatusEnum.FAILED ? task.error : undefined;
  }

  static GetTaskResponse = (taskManager: ActionTask[], taskName: string) => {
    const task = taskManager.find(t => t.taskName == taskName);
    return task?.response;
  }
}

export class TaskHelper {
  /**
  * Check if a task is in completed status.
  * Completed - COMPLETED/FAILED
  *
  * @param task Task
  */
  static IsTaskInCompletedStatus = (task: ActionTask) => task.status === TaskStatusEnum.COMPLETED || task.status === TaskStatusEnum.FAILED;

  /**
  * Check if a task is in executing status.
  * Executing - EXECUTING/TIMEOUT/RESUMING
  *
  * @param task Task
  */
  static IsTaskInExecutingStatus = (task: ActionTask) => !TaskHelper.IsTaskInCompletedStatus(task);
}
